import classnames from 'classnames/bind'
import { Fragment, useEffect, useState } from 'react'
import type { Variant } from '~/@types/product'

import { CartItem } from '~/components/UI/AddToCartButton'
import { ImageProps } from '~/components/UI/Image'
import ProductAction from '~/components/UI/ProductHeader/ProductStickyCta/ProductAction'
import ProductInfo from '~/components/UI/ProductHeader/ProductStickyCta/ProductInfo'
import ProductOptions from '~/components/UI/ProductHeader/ProductStickyCta/ProductOptions'

import { useCssVariables } from '~/providers/CssVariablesProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

interface ProductStickyCtaProps {
  className?: string
  isDisplayed?: boolean
  images?: ImageProps[]
  name?: string
  subtitle?: string
  price?: string
  variants?: Variant[]
  selectedVariant?: Variant
  cartItems?: CartItem[]
  crossedOutPrice?: string
  handleAddToCart?: () => void
  isGiftCard?: boolean
  hasOnlyAddToCartButton?: boolean
}

function ProductStickyCta({
  className,
  isDisplayed,
  images,
  name,
  subtitle,
  variants,
  hasOnlyAddToCartButton,
  ...rest
}: ProductStickyCtaProps) {
  const [display, setDisplay] = useState(false)
  const { update } = useCssVariables()

  useEffect(() => {
    update('zendesk-icon', display ? 'none' : 'block')
  }, [display])

  return (
    <div className={cx(css.ProductStickyCta, className)}>
      {!hasOnlyAddToCartButton && (
        <Fragment>
          <ProductOptions
            variants={variants}
            active={display && isDisplayed}
            onClick={() => setDisplay(false)}
          />

          <ProductInfo images={images} name={name} subtitle={subtitle} />
        </Fragment>
      )}

      <ProductAction
        variants={variants}
        active={display}
        onClick={() => setDisplay(!display)}
        hasOnlyAddToCartButton={hasOnlyAddToCartButton}
        {...rest}
      />
    </div>
  )
}

export default ProductStickyCta
